<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">
    <b-form @submit.prevent="save">
      <b-card>
        <b-form-row>
          <lg-form-input invalidFeedback="Informe uma descrição válida!" description="" :error="$v.form.descricao"
            v-model="form.descricao" label="Descrição*" cols="12" sm="9" />
        </b-form-row>
        <b-form-row>
          <lg-form-input invalidFeedback="Informe um número válido!" description="" :error="$v.form.numero"
            v-model="form.numero" label="Número*" cols="12" sm="3" />
        </b-form-row>

        <b-form-row>
          <b-form-group class="col-12">
            <b-form-checkbox v-model="form.usarFatorConversao" :value="1" :unchecked-value="0">
              Utiliza fator de conversão
            </b-form-checkbox>
          </b-form-group>
          <b-form-group class="col-12">
            <b-form-checkbox v-model="form.usarQtdDecimais" :value="1" :unchecked-value="0">
              Utiliza quantidade com demais no Registro de Entrada
            </b-form-checkbox>
          </b-form-group>
          <b-form-group class="col-12">
            <b-form-checkbox v-model="form.usarRe" :value="1" :unchecked-value="0">
              Utiliza produtos deste grupo nos Registros de Entrada
            </b-form-checkbox>
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group label="Status:*">
            <b-form-radio-group v-model="form.situacao" :options="statusOptions" size="sm"
              name="status-inline"></b-form-radio-group>
          </b-form-group>
        </b-form-row>
        <div class="d-flex justify-content-center align-items-center w-100">
          <b-button type="submit" variant="success" style="height: 40px" pill size="md" @submit="save">
            <div class="btn-size-alinhamento">
              <b-icon scale="2" icon="check-circle" />
            </div>
          </b-button>
          <b-button class="ml-2" @click="cancelar" variant="danger" style="height: 40px" pill size="md">
            <div class="btn-size-alinhamento">
              <b-icon scale="2" icon="x-circle" />
            </div>
          </b-button>
        </div>
      </b-card>
    </b-form>
  </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { FormResourceMixin } from "@/core/mixins/resource"
import GrupoProdutoService from "@/core/api/GrupoProdutoService.js"

export default {
  name: "GrupoProdutoForm",
  components: {
    LgFormInput,
  },
  mixins: [FormResourceMixin],

  validations: {
    form: {
      descricao: { required },
      situacao: { required },
    },
  },

  props: {
    id: Number,
    prefix: {
      type: String,
      default: "Grupo de Produto",
    },
  },

  computed: {
    formIsValid() {
      return !this.$v.$invalid
    },
  },

  data() {
    return {
      showModal: true,
      title: " > Cadastro",
      isBusy: false,
      form: {
        id: null,
        situacao: 1,
        descricao: "",
        usarFatorConversao: 0,
        usarQtdDecimais: 0,
        usarRe: 0,
      },
      statusOptions: [
        { text: "Ativo", value: 1 },
        { text: "Inativo", value: 0 },
      ],
    }
  },
  async mounted() {
    this.$GrupoProdutoService = new GrupoProdutoService()
    if (this.id) {
      const { data } = await this.$GrupoProdutoService.findById(this.id)
      this.form = data
    }
  },
  methods: {
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch()
        this.$notify({
          type: "danger",
          message: "OPS! Verifique os campos do cadastro.",
        })
        return
      }
      try {
        await this.$GrupoProdutoService.save(this.form).then(response => {
          if (
            response.status == 200 ||
            response.status === 204 ||
            response.status === 201
          ) {
            this.$notify({
              type: "success",
              message: "Cadastro salvo com sucesso!",
            })
            this.$emit("close")
          } else {
            this.$notify({
              type: "danger",
              message:
                "Ocorreu um erro ao salvar o cadastro. Verifique se já existe um grupo com o mesmo número",
            })
          }
        })
      } catch (e) {
        this.$notify({
          type: "danger",
          messa: "Erro ao salvar grupo de produto",
        })
      }
    },

    cancelar() {
      this.$emit("close")
    },
  },
}
</script>
